var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 15.2222C19 15.6937 18.8104 16.1459 18.4728 16.4793C18.1352 16.8127 17.6774 17 17.2 17H2.8C2.32261 17 1.86477 16.8127 1.52721 16.4793C1.18964 16.1459 1 15.6937 1 15.2222V2.77778C1 2.30628 1.18964 1.8541 1.52721 1.5207C1.86477 1.1873 2.32261 1 2.8 1H7.03425C7.20041 1 7.35572 1.08254 7.44868 1.22026L8.95132 3.4464C9.04428 3.58412 9.19959 3.66667 9.36575 3.66667H17.2C17.6774 3.66667 18.1352 3.85397 18.4728 4.18737C18.8104 4.52076 19 4.97295 19 5.44444V15.2222Z",
    stroke: "#888281",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.eccf3f28d39053f1d6edfed42177f173.svg";
export { ForwardRef as ReactComponent };